import { render, staticRenderFns } from "./SetupAssistent.vue?vue&type=template&id=3cd0c74e&scoped=true&"
import script from "./SetupAssistent.vue?vue&type=script&lang=ts&"
export * from "./SetupAssistent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0c74e",
  null
  
)

export default component.exports